/*
 * KnowledgeMapsList Messages
 *
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  knowledgeMapsListHeaderName: {
    id: 'app.name',
    defaultMessage: 'Name',
  },
  knowledgeMapsListHeaderModified: {
    id: 'app.modified',
    defaultMessage: 'Modified',
  },
  knowledgeMapsListHeaderItems: {
    id: 'app.items',
    defaultMessage: 'Items',
  },
  download: {
    id: `app.download`,
    defaultMessage: 'Download',
  },
  delete: {
    id: `app.delete`,
    defaultMessage: 'Delete',
  },
  duplicate: {
    id: `app.duplicate`,
    defaultMessage: 'Duplicate',
  },
  overwrite: {
    id: `app.overwrite`,
    defaultMessage: 'Overwrite',
  },
});
